import { IpWebComponent } from '../../web-components/ip-web-component';
import { TimelineComponentHelper } from './TimelineComponentHelper';

const fullImageSlideTemplate = document.createElement('template');
fullImageSlideTemplate.innerHTML = `
<style>
    :host {
        --background-color: #fff;
        --header-font-size: 2rem;
        --text-box-width: 33%;
        --text-box-padding: 2rem;
        --slide-min-height: 600px;
    }
    .slide-wrapper {
        min-height: var(--slide-min-height);
        position: relative;
        background-position: center;
        background-size: cover;
    }
    .text-container {
        width: var(--text-box-width);
        position: absolute;
        bottom: 0;
        left: 0;
        background: rgb(249, 249, 249);
        padding: var(--text-box-padding);
    }
    .title {
        margin: 0;
        font-size: var(--header-font-size);
    }
    .text {
        margin-top: 0;
    }
    .apply-animation {
        opacity: 0;
    }
    .animate-in {
        opacity: 0;
        animation: fade-up var(--animation-duration, 1s);
        animation-fill-mode: forwards;
        animation-delay: var(--animation-delay);
    }

    @media(max-width: 768px) {
        :host {
            --header-font-size: 1.8rem;
            --text-box-width: 50%;
            --slide-min-height: 500px;
        }
    }

    @media(max-width: 576px) {
        :host {
            --header-font-size: 1.6rem;
            --text-box-width: 100%;
            --slide-min-height: 400px;
        }
    }

    @keyframes fade-up {
        0% {
            opacity: 0;
            transform: translateY(50px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>
<div class="slide-wrapper">
    <div class="text-container">
        <h1 class="title apply-animation"></h1>
        <p class="text apply-animation"></p>
    </div>
</div>
`;

class TimelineSlideFullImage extends IpWebComponent {
    private unregisterAnimation: () => void = () => {};
    private timelineComponentHelper: TimelineComponentHelper | undefined;

    constructor() {
        super(fullImageSlideTemplate);
    }

    // Init component.
    connectedCallback() {
        this.timelineComponentHelper = new TimelineComponentHelper(this);

        // Set background image.
        const backgroundImgUrl = this.getProp('bg-img-url');
        if (backgroundImgUrl) {
            const slideWrapperElm = this.queryUnsafe<HTMLElement>('.slide-wrapper');
            slideWrapperElm.style.backgroundImage = `url('${backgroundImgUrl}')`;
            const [focusX, focusY] = [this.getProp('bg-focus-x', '50'), this.getProp('bg-focus-y', '50')];
            slideWrapperElm.style.backgroundPosition = `${focusX}% ${focusY}%`;
        } else {
            console.error('Background image is not set for full image slide.');
        }

        // Setup animated text elements in the component.
        this.timelineComponentHelper.setupAnimatedTextElm('.title', 'title', false, 'titleDelay', 'titleDuration');
        this.timelineComponentHelper.setupAnimatedTextElm('.text', 'text', false, 'textDelay', 'textDuration');

        const animatedElmsInShadow = this.queryAll<HTMLElement>('.apply-animation');
        this.unregisterAnimation = this.timelineComponentHelper.enableEnterExitAnimations(
            animatedElmsInShadow,
            'animate-in'
        );
    }

    disconnectedCallback() {
        this.unregisterAnimation();
    }
}

// Define element, if not already defined.
if (customElements.get('slide-full-image') === undefined) {
    customElements.define('slide-full-image', TimelineSlideFullImage);
}
